'use client';

import type { ComponentProps, ReactNode } from 'react';
import { IntlErrorCode, NextIntlClientProvider } from 'next-intl';
import { DEFAULT_TIME_ZONE } from '@/core/constants';

type IntlClientProviderProps = {
  children: ReactNode;
  locale: string;
  messages: ComponentProps<typeof NextIntlClientProvider>['messages'];
};

export default function IntlClientProvider({
  children,
  locale,
  messages,
}: IntlClientProviderProps) {
  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      timeZone={DEFAULT_TIME_ZONE}
      getMessageFallback={({ key }) => key}
      onError={error => {
        if (error.code === IntlErrorCode.MISSING_MESSAGE) {
          return;
        }

        console.error(error);
      }}
    >
      {children}
    </NextIntlClientProvider>
  );
}
